export default __webpack_public_path__ + "static/media/feather.3fa166a5.woff";